import type {
  AbortError,
  HttpError,
  RequestError,
  TimeoutError,
} from './error';

export const isHttpError = (error: Error): error is HttpError => {
  return (error as RequestError).name === 'HTTP_ERROR';
};

export const isAbortError = (error: Error): error is AbortError => {
  return (error as RequestError).name === 'ABORT_ERROR';
};

export const isTimeoutError = (error: Error): error is TimeoutError => {
  return (error as RequestError).name === 'TIMEOUT_ERROR';
};

export const isNetworkFail = (error: Error) => {
  return isTimeoutError(error) || !(error as HttpError).status;
};

export const isServerError = (error: Error) => {
  return isHttpError(error) && error.status >= 500;
};

export const isAuthError = (error: Error): error is HttpError => {
  return isHttpError(error) && error.status === 401;
};
